import { Injectable } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { AppConstants } from '../models/app.constants';
import { enableDebugTools } from '@angular/platform-browser';

@Injectable()
export class NotificationsSvc {

  public isNotificationActive = false;
  private constants = AppConstants.notifications;
  constructor(private notifSvc: NotificationsService) {
  }

  public productNotFound() {
    this.showNotification('error', this.constants.productNotFound.title, this.constants.productNotFound.content);
  }

  public gtinAlreadyExists() {
    this.showNotification('info', this.constants.gtinAlreadyExists.title, this.constants.gtinAlreadyExists.content, { timeOut: 15000 });
  }

  public serverError() {
    this.showNotification('error', this.constants.serverError.title, this.constants.serverError.content);
  }

  public preferencesError() {
    this.showNotification('error', this.constants.preferencesError.title, this.constants.preferencesError.content);
  }

  public companyMissing() {
    this.showNotification('error', this.constants.companyMissing.title, this.constants.companyMissing.content, { timeOut: 15000 });
  }

  public categoryUpdated() {
    this.showNotification('success', this.constants.categoryUpdated.title, this.constants.categoryUpdated.content, { timeOut: 15000, theClass: 'categoryUpdated' });
  }

  public noGtinAvailable() {
    this.showNotification('error', this.constants.noGtinAvailable.title, this.constants.noGtinAvailable.content, {
      timeOut: 15000,
      theClass: 'noGtinAvailable'
    });
  }

  public wrongImageType() {
    this.showNotification('info', this.constants.imagesUpload.wrongType.title, this.constants.imagesUpload.wrongType.content);
  }

  public imageTooBig() {
    this.showNotification('info', this.constants.imagesUpload.wrongSize.title, this.constants.imagesUpload.wrongSize.content);
  }

  public queueLimitReached() {
    this.showNotification('info', this.constants.imagesUpload.queueLimit.title, this.constants.imagesUpload.queueLimit.content);
  }

  public invalidImageUrl() {
    this.showNotification('info', this.constants.invalidImageUrl.title, this.constants.invalidImageUrl.content);
  }

  public wrongImportFileType() {
    this.showNotification('info', this.constants.productImport.wrongType.title, this.constants.productImport.wrongType.content);
  }

  public userDisconnected() {
    this.showNotification('alert', this.constants.userDisconnected.title, this.constants.userDisconnected.content);
  }

  public wrongTime() {
    this.showNotification('alert', this.constants.wrongTime.title, this.constants.wrongTime.content);
  }

  public importFileTooBig() {
    this.showNotification('info', this.constants.productImport.wrongSize.title, this.constants.productImport.wrongSize.content);
  }

  public importFileValidationError(isBundle = false) {
    const content = isBundle
      ? this.constants.productImport.validationError.bundleContent
      : this.constants.productImport.validationError.content;
    this.showNotification('info', this.constants.productImport.validationError.title, content);
  }

  public importFileUnsupportedEncodingError() {
    this.showNotification('info', this.constants.productImport.unsupportedEncoding.title, this.constants.productImport.unsupportedEncoding.content);
  }

  public fileSizeLimitExceededImportGtins() {
    this.showNotification('warn', this.constants.productImport.fileSizeLimitExceededGtinsImport.title, this.constants.productImport.fileSizeLimitExceededGtinsImport.content);
  }

  public importFileEmptyError() {
    this.showNotification('info', this.constants.productImport.emptyFile.title, this.constants.productImport.emptyFile.content);
  }

  public drainedWeightError() {
    this.showNotification('info', this.constants.productImport.drainedWeight.title, this.constants.productImport.drainedWeight.content);
  }

  public importInProgress() {
    const notification = this.constants.productImport.importInProgress;
    this.showNotification('info', notification.title, notification.content);
  }

  public createProductValidation() {
    const dataLayer = (window as any).dataLayer;
    if (dataLayer) {
      dataLayer.push({ event: 'creationFailed' });
    }
    this.showNotification('info', this.constants.createProductValidation.title, this.constants.createProductValidation.content, { timeOut: 15000 });
  }

  public updateProductValidation() {
    this.showNotification('info', this.constants.updateProductValidation.title, this.constants.updateProductValidation.content, { timeOut: 15000 });
  }

  public packingUnityEditionDisabled() {
    this.showNotification('alert', this.constants.packingUnityEditionDisabled.title, this.constants.packingUnityEditionDisabled.content);
  }

  public noVcsCategoryChosen() {
    this.showNotification('alert', this.constants.noClassificationChosen.title, this.constants.noClassificationChosen.content);
  }

  public userUnauthorizedToConnect() {
    this.showNotification('alert', this.constants.userUnauthorizedToConnect.title, this.constants.userUnauthorizedToConnect.content);
  }

  public uncompletedInscriptionProcess() {
    this.showNotification('error', this.constants.uncompletedInscriptionProcess.title, this.constants.uncompletedInscriptionProcess.content);
  }

  public shareUrlCopied() {
    this.showNotification('info', this.constants.shareUrlCopied.title, this.constants.shareUrlCopied.content);
  }

  public selectPrefixMin() {
    this.showNotification('error', this.constants.selectPrefixMin.title, this.constants.selectPrefixMin.content);
  }

  public wrongFoodAllergen() {
    this.showNotification('warn', this.constants.wrongFoodAllergen.title, this.constants.wrongFoodAllergen.content);
  }

  public wrongNutriscore() {
    this.showNotification('info', this.constants.wrongNutriscore.title, this.constants.wrongNutriscore.content);
  }

  public wrongFoodNutriment() {
    this.showNotification('warn', this.constants.wrongFoodNutriment.title, this.constants.wrongFoodNutriment.content);
  }

  public sugarSupToCarbohydrates() {
    this.showNotification('warn', this.constants.sugarSupToCarbohydrates.title, this.constants.sugarSupToCarbohydrates.content);
  }

  public wrongNumberOfDecimalsDigits() {
    this.showNotification('warn', this.constants.nutrimentsDecimalsError.title, this.constants.nutrimentsDecimalsError.content);
  }

  public mandatoryProductName(isBundle: boolean) {
    const title = isBundle ? this.constants.mandatoryProductName.bundleTitle : this.constants.mandatoryProductName.title;
    const content = isBundle ? this.constants.mandatoryProductName.bundleContent : this.constants.mandatoryProductName.content;
    this.showNotification('info', title, content);
  }

  public exportInProgress() {
    this.showNotification('info', this.constants.exportInProgress.title, this.constants.exportInProgress.content);
  }
  private showNotification(type: string, title: string, content: string, options?: any) {
    this.notifSvc[type](title, content, options);
    this.isNotificationActive = true;
    setTimeout(() => {
      this.isNotificationActive = false;
    }, options?.timeOut ?? 5000);
  }
}
